import React from 'react';
import RedirectToZenDesk from './_redirectToZenDesk';

function IndexPage({ location }) {
  return <RedirectToZenDesk location={location} />;
}

export default IndexPage;
